import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Login";
import AdminPanel from "./AdminPanel"; // Admin panel page
import PrivacyPolicy from "./PrivacyPolicy"; // Privacy Policy page
import NewPrivacyPolicy from "./NewPrivacyPolicy";
import DeleteAccount from "./DeleteAccount";
import Layout from "./Layout"; 
import ManageUsers from './ManageUsers'; // Manage Users page
import SubscriptionPlan from './SubscriptionPlan';
import UserDetails from "./UserDetails"; // User details page
import EditUser from "./EditUser"; // Edit user page
import PrivateRoute from "./components/PrivateRoute"; // Import the PrivateRoute component
import ReferralRedirect from "./ReferralRedirect";
import  DailylimitSwipesCount  from './DailylimitSwipesCount';


function App() {
  return (
    <Router>
      <Routes>
        {/* Parent route with Layout component */}
        <Route element={<Layout />}>
          {/* Protected Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <PrivateRoute>
                <PrivacyPolicy />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-users"
            element={
              <PrivateRoute>
                <ManageUsers />
              </PrivateRoute>
            }
          />
             <Route
            path="/subscription-plan"
            element={
              <PrivateRoute>
                <SubscriptionPlan />
              </PrivateRoute>
            }
          />
          <Route
            path="/dailylimit-swipecount"
            element={
              <PrivateRoute>
                <DailylimitSwipesCount />
              </PrivateRoute>
            }
          />
          <Route path="/refer" element={<ReferralRedirect />} />
          <Route path="/new-privacy-policy" element={<NewPrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/user-details/:userId" element={<UserDetails />} />
          <Route path="/edit-user/:userId" element={<EditUser />} />
        </Route>

        {/* Login page */}
        <Route path="/login" element={<Login />} />
        
        {/* Default route */}
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
